export default function RiskWarningBar () { 
    var bar = document.querySelector(".risk-warning-bar"); 
    if (!(bar instanceof Element)) return; 
    var isClosed = window.localStorage.getItem("riskWarningBarIsClosed") === "true"; 
    bar.classList.toggle("is-closed", isClosed); 
    var close = document.querySelector(".risk-warning-bar_close a"); 
    if (!(close instanceof Element)) return; 
    close.addEventListener("click", function (event) { 
        event.preventDefault(); bar.classList.add("is-closed"); 
        window.localStorage.setItem("riskWarningBarIsClosed", "true"); 
    }); 
};